import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/d2262a1d-1da8-452f-a65c-ca78526f7144.png" 
              alt="Desguace Barcelona Logo" 
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isActive('/') ? 'text-[#ff6b35]' : isScrolled ? 'text-gray-900 hover:text-[#ff6b35]' : 'text-white hover:text-[#ff6b35]'}`}
            >
              Inicio
            </Link>
            <Link 
              to="/vender-coche-barcelona" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isActive('/vender-coche-barcelona') ? 'text-[#ff6b35]' : isScrolled ? 'text-gray-900 hover:text-[#ff6b35]' : 'text-white hover:text-[#ff6b35]'}`}
            >
              Vender Coche
            </Link>
            <div 
              className="relative"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <button 
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1 ${isScrolled ? 'text-gray-900 hover:text-[#ff6b35]' : 'text-white hover:text-[#ff6b35]'}`}
              >
                Servicios
                <i className={`ri-arrow-down-s-line text-base transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isServicesOpen && (
                <div className="absolute top-full left-0 pt-2">
                  <div className="w-64 bg-white rounded-lg shadow-xl py-2 border border-gray-100">
                    <Link 
                      to="/vender-coche-siniestro-barcelona" 
                      className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#ff6b35] transition-colors cursor-pointer"
                    >
                      <i className="ri-car-line mr-2"></i>Coches Siniestrados
                    </Link>
                    <Link 
                      to="/vender-coche-averiado-barcelona" 
                      className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#ff6b35] transition-colors cursor-pointer"
                    >
                      <i className="ri-tools-line mr-2"></i>Coches Averiados
                    </Link>
                    <Link 
                      to="/vender-coche-sin-itv-barcelona" 
                      className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#ff6b35] transition-colors cursor-pointer"
                    >
                      <i className="ri-file-warning-line mr-2"></i>Coches Sin ITV
                    </Link>
                    <Link 
                      to="/vender-coche-accidentado-barcelona" 
                      className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#ff6b35] transition-colors cursor-pointer"
                    >
                      <i className="ri-alert-line mr-2"></i>Coches Accidentados
                    </Link>
                    <Link 
                      to="/tasacion-coche-barcelona" 
                      className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#ff6b35] transition-colors cursor-pointer"
                    >
                      <i className="ri-price-tag-3-line mr-2"></i>Tasación Gratuita
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <a 
              href="#proceso" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-900 hover:text-[#ff6b35]' : 'text-white hover:text-[#ff6b35]'}`}
            >
              Cómo Funciona
            </a>
            <a 
              href="#contacto" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-900 hover:text-[#ff6b35]' : 'text-white hover:text-[#ff6b35]'}`}
            >
              Contacto
            </a>
            <Link 
              to="/zonas" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isActive('/zonas') ? 'text-[#ff6b35]' : isScrolled ? 'text-gray-900 hover:text-[#ff6b35]' : 'text-white hover:text-[#ff6b35]'}`}
            >
              Zonas
            </Link>
          </div>

          <div className="hidden lg:flex items-center space-x-4">
            <a 
              href="tel:+34932932913" 
              className={`flex items-center space-x-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-900 hover:text-[#ff6b35]' : 'text-white hover:text-[#ff6b35]'}`}
            >
              <i className="ri-phone-line text-lg"></i>
              <span>932 932 913</span>
            </a>
            <a 
              href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20tasar%20mi%20coche%20gratis" 
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#25D366] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#1da851] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Tasación Gratis
            </a>
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors cursor-pointer ${isScrolled ? 'text-gray-900' : 'text-white'}`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <Link to="/" className="block py-2 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
              Inicio
            </Link>
            <Link to="/vender-coche-barcelona" className="block py-2 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
              Vender Coche
            </Link>
            <div className="border-t border-gray-100 pt-2 mt-2">
              <p className="text-xs font-semibold text-gray-500 uppercase mb-2 px-2">Servicios</p>
              <Link to="/vender-coche-siniestro-barcelona" className="block py-2 pl-4 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                <i className="ri-car-line mr-2"></i>Coches Siniestrados
              </Link>
              <Link to="/vender-coche-averiado-barcelona" className="block py-2 pl-4 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                <i className="ri-tools-line mr-2"></i>Coches Averiados
              </Link>
              <Link to="/vender-coche-sin-itv-barcelona" className="block py-2 pl-4 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                <i className="ri-file-warning-line mr-2"></i>Coches Sin ITV
              </Link>
              <Link to="/vender-coche-accidentado-barcelona" className="block py-2 pl-4 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                <i className="ri-alert-line mr-2"></i>Coches Accidentados
              </Link>
              <Link to="/tasacion-coche-barcelona" className="block py-2 pl-4 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                <i className="ri-price-tag-3-line mr-2"></i>Tasación Gratuita
              </Link>
            </div>
            <a href="#proceso" className="block py-2 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
              Cómo Funciona
            </a>
            <a href="#contacto" className="block py-2 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
              Contacto
            </a>
            <Link to="/zonas" className="block py-2 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
              Zonas
            </Link>
            <a href="tel:+34932932913" className="block py-2 text-gray-900 hover:text-[#ff6b35] font-medium cursor-pointer">
              <i className="ri-phone-line mr-2"></i>932 932 913
            </a>
            <a 
              href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20tasar%20mi%20coche%20gratis" 
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-[#25D366] text-white px-6 py-3 rounded-full text-center font-semibold hover:bg-[#1da851] transition-all whitespace-nowrap cursor-pointer" 
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Tasación Gratis
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
